<template>
  <v-container>
    <v-row>
      <v-col>
        <v-breadcrumbs
          class="mb-0 ml-0 pb-0 pl-0"
          :items="breadcrumbList"
        ></v-breadcrumbs>
        <h1>{{ title }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    breadcrumbList() {
      const {
        $route: { matched },
      } = this;

      const breadcrumbList = matched.map(route => {
        const {
          path,
          meta: { breadcrumb },
        } = route;
        return {
          href: path,
          text: breadcrumb,
        };
      });

      if (!breadcrumbList.length) {
        return breadcrumbList;
      }

      // Disable last breadcrumb
      breadcrumbList[breadcrumbList.length - 1].disabled = true;

      return breadcrumbList;
    },
    title() {
      const {
        $route: {
          meta: { title },
        },
      } = this;

      return title;
    },
  },
  async created() {
    await Promise.all([this.attributeGetList(), this.optionGetList()]);
  },
  methods: {
    ...mapActions({
      attributeGetList: "attribute/list",
      optionGetList: "option/list",
    }),
  },
};
</script>
